import React, { useState } from 'react';
import { makeStyles, createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Button, Dialog, IconButton } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';

import CloseIcon from '@material-ui/icons/Close';
import { DialogAction } from '../../../function/useModal';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

type DialogTitleProps = {
  children: React.ReactNode;
  onClose: () => void;
};

const DialogTitle: React.FC<DialogTitleProps> = (props) => {
  const { children, onClose, ...other } = props;
  const classes = useStyles(props);
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
    </MuiDialogTitle>
  );
};
const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

type MessageDialogProps = {
  dialog: DialogAction<MessageStyleDialogResponse>;
  title?: string;
  message: string;
  action?: string;
};

export type MessageStyleDialogResponse = {};

const MessageStyleDialog: React.FC<MessageDialogProps> = (props: MessageDialogProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [mode, setMode] = useState<boolean>(true);

  const msgs = props.message.split('\n');

  return (
    <>
      <Dialog
        open={isOpen}
        fullScreen={false}
        onEntered={(e) => {}}
        onExited={(e) => {
          if (mode) {
            props.dialog.apply({});
          } else {
            props.dialog.cancel();
          }
        }}
      >
        <DialogTitle
          onClose={() => {
            props.dialog.apply([]);
          }}
        >
          {props.title ?? t('MessageDialog.確認', '確認')}
        </DialogTitle>
        <DialogContent dividers>
          <div style={{ display: 'flow' }}>
            {msgs.map((msg, index) => (
              <div key={index}>{msg}</div>
            ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            variant="contained"
            color="primary"
            startIcon={<CloseIcon />}
            onClick={(e) => {
              setIsOpen(false);
              setMode(true);
            }}
          >
            {props.action ?? 'OK'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MessageStyleDialog;
